import React, {useContext} from 'react'
import ListBrandsContext from "../context/ListBrandsContext";
import SearchGroup from "../../../components/InputSelect/SearchGroup"

const ListBrandsFilters = (props) => {
    const {filters, setState} = useContext(ListBrandsContext)

    const options = [
        {title: 'Store', key: 'store', value: filters.store || ''},
        {title: 'Brand name', key: 'name', value: filters.name || ''}
    ]

    const _handleChangeFilterGroupState = (paramFilter) => {
        const _filters = {
            ...filters,
            ...paramFilter
        }

        for (let i=0;i<options.length;i++) {
            if(options[i].key !== Object.keys(paramFilter)[0]) delete _filters[options[i].key]
        }

        if(Object.values(paramFilter)[0].length === 0) delete _filters[Object.keys(paramFilter)[0]]

const filterKey = Object.keys(paramFilter)[0];
        const filterValue =Object.values(paramFilter)[0].toString();
        const finalFilter = {
            [filterKey]: filterValue
        }

        setState(finalFilter)
    }

    return (
        <div className="d-flex">
            <div className="itemFilterGroup mb-3 mr-3">
                <SearchGroup options={options} onSearch={_handleChangeFilterGroupState}/>
            </div>
        </div>
    )
}

export default ListBrandsFilters
